<template>
  <div id="commonFeedback">
    <van-popup v-model="showFeedback" closeable round>
      <commonTouchLoading v-if="loading"></commonTouchLoading>
      <div v-else>
        <p>Feedback</p>
        <div class="describe">
          Describe the problem encountered
          <van-field
            rows="4"
            class="textareaField"
            v-model="content"
            placeholder="Please Enter"
            type="textarea"
            maxlength="200"
            show-word-limit
            autosize
          >
          </van-field>
        </div>
        <common-btn class="btn" :click="submit">Submit</common-btn>
        <p class="describe">
          {{
            list.showChannel === "phone"
              ? "You can also call customer service directly"
              : "You Can Also Contact Us Through The Email, and feedback with your name, phone number and app name :"
          }}
        </p>
        <div class="info">
          <p class="text">
            {{ list.showChannel === "phone" ? list.phone : list.email }}
          </p>
          <p
            class="copy"
            id="copy"
            :data-clipboard-text="
              list.showChannel === 'phone' ? list.phone : list.email
            "
            @click="copy"
          >
            Copy
          </p>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { customerServiceInfo, complaint } from '@/views/user/lib.js'
import { Toast } from 'vant'
import ClipboardJS from 'clipboard'

export default {
  name: 'commonFeedback',
  props: {
    value: { type: Boolean, default: true }
  },
  data () {
    return {
      content: '',
      list: [],
      loading: true
    }
  },
  computed: {
    showFeedback: {
      get () {
        return this.value
      },
      set (v) {
        this.$emit('input', v)
      }
    }
  },
  created () {
    this.customerServiceInfo().finally(() => {
      this.loading = false
    })
  },
  methods: {
    async customerServiceInfo () {
      const res = await customerServiceInfo()
      this.list = res
    },
    copy () {
      if (this.clipboard) {
        this.clipboard.destroy()
      }
      this.clipboard = new ClipboardJS('#copy')
      this.clipboard.on('success', function (e) {
        Toast('Copy Success')
        e.clearSelection()
      })
    },
    async submit () {
      if (this.content) {
        const res = await complaint({
          content: this.content,
          type: 1,
          phone: localStorage.getItem('phone')
        })
        if (res.code === '200') {
          Toast('Submitted successfully')
          this.$emit('input', false)
          this.content = ''
        }
      }
    }
  }
}
</script>

<style scoped lang='less'>
#commonFeedback {
  .describe {
    font-size: 13px;
    color: #62616b;
    font-weight: normal;
    margin-top: 14px;
    text-align: left;
    .textareaField {
      border-radius: 8px;
      background: #f8f8f8;
      margin-top: 12px;
      /deep/ .van-field__word-limit {
        color: #d5d4d8;
      }
    }
  }
  .btn {
    font-size: 16px;
    margin-top: 16px;
  }
  .info {
    font-size: 14px;
    display: flex;
    align-items: stretch;
    margin-top: 14px;
    justify-content: space-between;
    min-height: 40px;
    width: 100%;
  }

  .text {
    background: #f4f2ff;
    border-radius: 24px;
    color: #12033a;
    font-weight: 500;
    word-break: break-all;
    text-align: left;
    flex-grow: 1;
    margin-right: 10px;
    padding: 0 12px;
    display: flex;
    align-items: center;
  }

  .copy {
    font-weight: 600;
    background: #01947f;
    border-radius: 24px;
    color: #ffffff;
    width: auto;
    padding: 0 12px;
    text-align: center;
    display: flex;
    align-items: center;
  }

  .van-popup {
    padding: 31px 20px 20px;
    width: 75%;
    min-height: 60%;
  }
}
</style>
